import {
  hasOneOf
} from '@/libs/tools';
import config from '@/config';
const {
  title,
  useI18n
} = config


/**
 * @description 判断目标数组元素是否在匹配数组内
 * @param {Array} access 匹配数组，用户权限数组，如 ['super_admin', 'admin']
 * @param {Object} route 目标对象, $route实例
 */
const hasAccess = (access, route) => {
  if (route.meta && route.meta.access) return hasOneOf(access, route.meta.access)
  else return true
}
/**
 * @description  获取根路由的name
 * @param {object} routeItem 路由对象
 */
export const getParentName = (routeItem) => {
  const [matched, name] = [routeItem.matched, routeItem.name];
  let parentName = "";
  if (matched && matched.length > 1) {
    matched.forEach(item => {
      if (item.name === name) {
        if (item.parent.parent) {
          const obj = {
            matched: [item.parent],
            name: item.parent.parent.name
          };
          parentName = getParentName(obj)
        } else {
          parentName = item.parent.name;
        }
      }
    });
  } else {
    parentName = name;
  }
  return parentName
}
/**
 * 权鉴
 * @param {object} to 即将跳转的路由
 * @param {array} access 用户权限数组
 * @param {object} routes 路由列表
 * @description 用户是否可跳转到该页
 */
export const canTurnTo = (to, access, routes) => {
  const parentName = getParentName(to);
  routes = routes.filter(item => item.name === parentName);
  const routePermissionJudge = (list) => {
    return list.some(item => {
      if (item.children && item.children.length) {
        return routePermissionJudge(item.children)
      } else if (item.name === to.name) {
        return hasAccess(access, item)
      }
    })
  }
  return routePermissionJudge(routes)
}

export const showTitle = (item, vm) => {
  let {
    title = ""
  } = item.meta
  if (!title) return title;
  if (useI18n) {
    title = vm.$t(item.name)
  } else
    title = (item.meta && item.meta.title) || item.name
  return title
}
/**
 * @description 根据当前跳转的路由设置显示在浏览器标签的title
 * @param {Object} routeItem 路由对象
 * @param {Object} vm Vue实例
 */
export const setTitle = (routeItem, vm) => {
  const pageTitle = showTitle(routeItem, vm)
  // const resTitle = pageTitle ? `${title} - ${pageTitle}` : title
  const resTitle = pageTitle || ""
  window.document.title = resTitle
}
/**
 *
 * @param {Object} xhr  XMLHttpRequest
 * @param {number|string} code 状态码
 * @param {Object} vm vue实例
 */
export const axiosErr = (xhr, code, vm) => {
  const name = code || (xhr.response && xhr.response.status || 404);
  if (vm) {
    vm.$router.push({
      name: name.toString()
    })
  } else {
    return name.toString()
  }
}
/**
 * @description 判断对象是否有子节点
 * @param {Object} item
 */
export const hasChild = (item) => {
  return item.children && item.children.length !== 0
}
/**
 * @description 判断路由页面是否在权限列表里面
 * @param {Object} item 路由对象
 * @param {Array} access 权限列表
 */
export const showThisMenuEle = (item, access) => {
  if (item.meta && item.meta.access && item.meta.access.length) {
    if (hasOneOf(item.meta.access, access)) return true
    else return false
  } else return true
}
/**
 * @description 通过路由获取菜单列表
 * @param {Object} router 路由对象
 * @param {Array} access 权限列表
 */
export const getMenuByRouter = (router, access) => {
  let arr = [];
  router.forEach(item => {
    if (item.meta && !item.meta.hideInMenu) {
      let obj = {
        icon: (item.meta && item.meta.icon) || '',
        name: item.name,
        meta: item.meta
      };
      if (item.children && item.children.length > 0) {
        obj.children = getMenuByRouter(item.children, access)
      }
      if (showThisMenuEle(item, access)) arr.push(obj);
    }
  });
  return arr;
}
/**
 * @description 置顶
 * @param {object} el dom节点(滚动节点)
 * @param {number} from 开始位置
 * @param {number} to 结束位置
 * @param {number} duration 持续时间
 * @param {fn} endCallback 完成后的回调
 */
export const scrollTop = (el, from = 0, to, duration = 500, endCallback) => {
  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = (
      window.webkitRequestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.msRequestAnimationFrame ||
      function (callback) {
        return window.setTimeout(callback, 1000 / 60)
      }
    )
  }
  const difference = Math.abs(from - to)
  const step = Math.ceil(difference / duration * 50)

  const scroll = (start, end, step) => {
    if (start === end) {
      endCallback && endCallback()
      return
    }

    let d = (start + step > end) ? end : start + step
    if (start > end) {
      d = (start - step < end) ? end : start - step
    }

    if (el === window) {
      window.scrollTo(d, d)
    } else {
      el.scrollTop = d
    }
    window.requestAnimationFrame(() => scroll(d, end, step))
  }
  scroll(from, to, step)
}



// WEBPACK FOOTER //
// ./src/libs/utils.js